import { css } from '@emotion/css'
import { StatsContainer } from '../StatsContainer'
import { StatsHeader } from '../stats_header/StatsHeader'
import { useStats } from '../../lib/ctx/stats'
import { useRef } from 'react'
import { useInView } from 'framer-motion'
import { getBestStreakResult } from '../../lib/utils'
import { ReaderInsight } from '../shared'
import { StreaksShareButton } from './StreaksShareButton'
import { useStatsPermission, useStatsZeroState } from '../../lib/hooks'
import { StreakInsight } from './StreakInsight'
import { StreakCalendar } from './streak_calendar/StreakCalendar'
import { StatsHeaderTitle } from '../stats_header'

export const StreakStats = () => {
  const [stats, theme, yearStatus, year] = useStats((s) => [
    s.stats,
    s.theme,
    s.yearStatus,
    s.year,
  ])
  const ref = useRef(null)
  const inView = useInView(ref, {
    once: true,
    amount: 1,
  })
  const { bestStreak, bestStreakUnit } = getBestStreakResult(stats)
  const zeroState = useStatsZeroState('streaks')
  const { isStatsOwner } = useStatsPermission()
  const isPastYear = yearStatus === 'past'

  const getContent = () => {
    if (zeroState && isStatsOwner) {
      if (yearStatus !== 'current') return null

      return (
        <ReaderInsight
          data-testid="reader-insight-streaks"
          label="How to get started"
          text="Add books to your Currently Reading list, then start a reading streak
        by tapping “I read today” on the For You feed."
          backgroundColor={theme.bg200}
        />
      )
    }

    return (
      <>
        {!zeroState ? (
          <StreakCalendar data-testid="streaks-stats-calendar" animate />
        ) : null}
        {!isPastYear && isStatsOwner ? <StreakInsight /> : null}
      </>
    )
  }

  return (
    <StatsContainer id="streaks" data-testid="stats-streaks" empty={zeroState}>
      <div
        ref={ref}
        className={css`
          width: 100%;
        `}
      >
        <StatsHeader actions={zeroState ? null : <StreaksShareButton />}>
          <StatsHeaderTitle
            top="Best reading streak"
            middle="0"
            bottom={
              <>
                {bestStreakUnit}
                <span
                  className={css`
                    margin-left: 4px;
                    opacity: 0.5;
                  `}
                >
                  {isPastYear
                    ? `in a row in ${year}`
                    : 'in a row this year so far'}
                </span>
              </>
            }
            counter={!zeroState ? { to: bestStreak } : undefined}
            animate={!zeroState && inView}
            infoButton={{
              text: (
                <>
                  Add books to your Currently Reading list, then start a reading
                  streak by tapping “I read today” on the For You feed.
                  <br />
                  <br />
                  Note that due to privacy concerns, we only show other users
                  what books you read if your Finished list is set to public.
                </>
              ),
            }}
          />
        </StatsHeader>
      </div>
      {getContent()}
    </StatsContainer>
  )
}
